import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-091675f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "how-can-we-help-card" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { class: "lists-wrapper" }
const _hoisted_5 = { class: "list" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_11 = { class: "list" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_17 = { class: "list" }
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-check" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicLogo = _resolveComponent("ClinicLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ClinicLogo, {
      class: "logo",
      diameter: "128px",
      "border-width": "8px",
      "border-color": "var(--color-neutral-white)"
    }),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(this.$mhat("HowCanWeHelpCard.TitleText")), 1),
    _createElementVNode("span", _hoisted_3, _toDisplayString(this.$mhat("HowCanWeHelpCard.MessageText")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          class: "icon-image",
          src: _ctx.imgTeam,
          alt: "team image"
        }, null, 8, _hoisted_6),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _hoisted_7,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.GeneralMedicalAdvice")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_8,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.Referrals")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_9,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.SinusInfections")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_10,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.BirthControlPrescriptions")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("img", {
          class: "icon-image",
          src: _ctx.imgNeedle,
          alt: "needle image"
        }, null, 8, _hoisted_12),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _hoisted_13,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.Prescriptions")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_14,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.LabResults")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_15,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.SkinInflammations")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_16,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.Utis")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("img", {
          class: "icon-image",
          src: _ctx.imgDocument,
          alt: "document image"
        }, null, 8, _hoisted_18),
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _hoisted_19,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.SickNotes")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_20,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.Colds")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_21,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.MentalHealth")), 1)
          ]),
          _createElementVNode("li", null, [
            _hoisted_22,
            _createTextVNode(_toDisplayString(this.$mhat("HowCanWeHelpCard.NutritionConcerns")), 1)
          ])
        ])
      ])
    ])
  ]))
}